import { render } from "./subAccountManage.vue?vue&type=template&id=773a540c"
import script from "./subAccountManage.vue?vue&type=script&lang=js"
export * from "./subAccountManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__